import Cookies from 'js-cookie';
import * as crypto from 'crypto-js';

export const initialMarquee = [
  {
    marqueeList: [
      { text: 'Confused about your health?', textColor: '#6e6e6e' },
      { text: 'Get your medical answers', textColor: '#6e6e6e' },
      { text: 'Consult Doctors at no cost!', textColor: '#6e6e6e' },
    ],
    sectionBgColorStart: 'transparent',
  },
];

export const successMarquee = [
  {
    marqueeList: [
      { text: 'We have received your details.', textColor: '#6e6e6e' },
      {
        text: 'Our Customer Care agent will contact you shortly.',
        textColor: '#6e6e6e',
      },
    ],
    sectionBgColorStart: 'transparent',
  },
];

export const formID = '27';

export const checkFormSubmitted = (articleData) => {
  const id = Cookies.get(`userLead-${articleData?.id}`);
  if (id) {
    const encodedWord = crypto.enc.Base64.parse(id); // encodedWord via Base64.parse()
    let decoded = crypto.enc.Utf8.stringify(encodedWord);
    return decoded;
  }
};
